<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "AnsprechpartnerIn"}}</h4>
</div>
<div class="modal-body">
	{{ERROR_ROW errors.error}}
	<form>
	<div class="row">
		{{#if canView.ctct_name}}
		<div class="col-sm-6">
			<div class="form-group">
				<label for="contactperson-street" class="control-label">{{TR "Name"}}</label>
				<input id="contact-name" class="form-control {{#if errors.name}}parsley-error{{/if}}" name="name" type="text" value="{{ formData.name }}" placeholder={{TR "Name"}}>
				{{#if errors.name}}
				<ul class="parsley-errors-list filled" id="js-name-error">
					<li class="parsley-required">{{TR "Name ist"}} {{TR errors.name}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		{{/if}}
		{{#if canView.ctct_phone}}
		<div class="col-sm-6">
			<div class="form-group">
				<label for="contactperson-number" class="control-label">{{TR "Telefonnummer"}}</label>
				<input id="contact-phone" class="form-control {{#if errors.phone}}parsley-error{{/if}}" name="phone" type="tel" value="{{ formData.phone }}" placeholder={{TR "Telefonnummer"}}>
				{{#if errors.phone}}
				<ul class="parsley-errors-list filled" id="js-phone-error">
					<li class="parsley-required">{{TR "Telefonnummer ist"}} {{TR errors.phone}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		{{/if}}
	</div>
	<div class="row">
		{{#if canView.ctct_email}}
		<div class="col-sm-6">
			<div class="form-group">
				<label for="contactperson-code" class="control-label">{{TR "E-Mail"}}</label>
				<input id="contact-email" class="form-control {{#if errors.email}}parsley-error{{/if}}" name="email" type="email" value="{{ formData.email }}" placeholder={{TR "E-Mail"}}>
				{{#if errors.email}}
				<ul class="parsley-errors-list filled" id="js-email-error">
					<li class="parsley-required">{{TR "E-Mail ist"}} {{TR errors.email}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
		{{/if}}
	</div>
	</form>

</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white js-cancel" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary js-submit" id="js-success">{{TR "Speichern"}}</button>
</div>
